import { useLazyQuery, useQuery } from "@apollo/client";
import { PRICE_RULES } from "../price-rule.queries";
import { PriceRulesQuery, PriceRulesQueryVariables } from "../../../__generated__/PriceRulesQuery";

export const usePriceRules = (variables: PriceRulesQueryVariables) => {
  return useQuery<PriceRulesQuery, PriceRulesQueryVariables>(PRICE_RULES, { variables });
};

export const useLazyPriceRules = () => {
  return useLazyQuery<PriceRulesQuery, PriceRulesQueryVariables>(PRICE_RULES);
};
